var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const u = up.util;
up.RenderResult = class RenderResult {
    constructor({ layer, target, renderOptions = {}, partialResults = [] } = {}) {
        this.layer = layer;
        this.target = target;
        this.renderOptions = renderOptions;
        this.fragments = this._partialPhase(partialResults, 'fragments').flat();
        this.finished = this._finish(partialResults);
    }
    _partialPhase(partialResults, phase, extraValue) {
        return u.compact([...u.map(partialResults, phase), extraValue]);
    }
    _finish(partialResults) {
        return __awaiter(this, void 0, void 0, function* () {
            let finishedPromises = this._partialPhase(partialResults, 'finished');
            let verifyFns = this._partialPhase(partialResults, 'verifyFinished', this.renderOptions.verifyFinished);
            yield Promise.all(finishedPromises);
            let finishedResult = this;
            for (let verifyFn of verifyFns) {
                let verifyerResult = yield verifyFn(finishedResult);
                finishedResult = verifyerResult || finishedResult;
            }
            return finishedResult;
        });
    }
    get none() {
        return !this.fragments.length;
    }
    get fragment() {
        return this.fragments[0];
    }
    get ok() {
        return !this.renderOptions.didFail;
    }
};
